import React from "react";
import FooterMarkdown from "./FooterMarkdown";
import FooterWordPressContent from "./FooterWordPressContent";

interface FooterContentModalProps {
  open: boolean;
  title: string;
  content: string;
  wordpressContentHtml?: string | null;
  wordpressContentLoading?: boolean;
  wordpressContentError?: string | null;
  onClose: () => void;
}

const FooterContentModal: React.FC<FooterContentModalProps> = ({
  open,
  title,
  content,
  wordpressContentHtml,
  wordpressContentLoading = false,
  wordpressContentError,
  onClose,
}) => {
  if (!open) {
    return null;
  }

  return (
    <div className="footer-modal-backdrop">
      <div
        className="footer-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="footer-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="footer-modal-header">
          <h2 id="footer-modal-title">{title}</h2>
          <button type="button" className="footer-modal-close" onClick={onClose} aria-label="Close footer content">
            ×
          </button>
        </div>
        <div className="footer-modal-body">
          {wordpressContentLoading ? (
            <p className="footer-content-status">Loading content…</p>
          ) : wordpressContentError ? (
            <p className="footer-content-status footer-content-status--error">{wordpressContentError}</p>
          ) : wordpressContentHtml !== undefined && wordpressContentHtml !== null ? (
            <FooterWordPressContent contentHtml={wordpressContentHtml} />
          ) : (
            <FooterMarkdown content={content} />
          )}
        </div>
      </div>
    </div>
  );
};

export default FooterContentModal;
